import * as HttpApiSchema from "@effect/platform/HttpApiSchema";
import {Schema} from "effect";

export const StarWriteOperation = Schema.Literal("star", "unstar");
export type StarWriteOperation = typeof StarWriteOperation.Type;

export class StarWriteError extends Schema.TaggedError<StarWriteError>()(
    "StarWriteError",
    {
        operation: StarWriteOperation,
        documentUid: Schema.String,
        reason: Schema.String,
    },
    HttpApiSchema.annotations({status: 500}),
) {}

export class StarAuthError extends Schema.TaggedError<StarAuthError>()(
    "StarAuthError",
    {
        reason: Schema.String,
    },
    HttpApiSchema.annotations({status: 401}),
) {}

export type StarError = StarWriteError | StarAuthError;
